var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cr-tabs"},[_c('el-tabs',_vm._b({attrs:{"lazy":false},on:{"input":function (val) { return _vm.$emit('input', val); }}},'el-tabs',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }